import React from "react";
import { Link } from "react-router-dom";

import { WWW_URL } from "../config/environment";

// Links to a marketing-site path. When the marketing site is hosted separately
// (the www/app split — REACT_APP_WWW_URL set), these render as real cross-host
// anchors to the marketing site; otherwise (single-domain dev) they stay as
// in-app SPA routes. Extra props (onClick, target, rel, ...) pass through.
export const MarketingLink = ({ to, className, children, ...rest }) =>
    WWW_URL ? (
        <a href={`${WWW_URL}${to}`} target="_blank" className={className} {...rest}>
            {children}
        </a>
    ) : (
        <Link to={to} className={className} {...rest}>
            {children}
        </Link>
    );

export default MarketingLink;
